import { render, staticRenderFns } from "./deleteAffiliateUser.vue?vue&type=template&id=5fd0a809"
import script from "./deleteAffiliateUser.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports